import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';

function Header({ user, onLogout, onMenuClick }) {
  const [churchName, setChurchName] = useState('Hosanna');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const updateChurchName = () => {
      if (!user) {
        setChurchName('Hosanna');
        return;
      }

      // For church_user and church_admin, check localStorage for selected church
      if (user.role === 'church_user' || user.role === 'church_admin') {
        const stored = localStorage.getItem('selectedChurch');
        if (stored) {
          try {
            const church = JSON.parse(stored);
            setChurchName(church.name || 'Hosanna');
          } catch (error) {
            setChurchName('Hosanna');
          }
        } else {
          setChurchName('Hosanna');
        }
      } else {
        // For super_admin or other roles, always show Hosanna
        setChurchName('Hosanna');
      }
    };

    updateChurchName();

    // Poll for changes in localStorage (since storage event only fires in other tabs)
    const interval = setInterval(updateChurchName, 500);

    // Also listen for custom event when church is selected/changed
    window.addEventListener('churchSelected', updateChurchName);

    return () => {
      clearInterval(interval);
      window.removeEventListener('churchSelected', updateChurchName);
    };
  }, [user]);

  const getRoleDisplay = (role) => {
    if (!role) return '';
    return role.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <>
      <AppBar 
        position="fixed"
        sx={{
          backgroundColor: '#aa3232'
        }}
      >
        <Toolbar>
          {isMobile && onMenuClick && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={onMenuClick}
              sx={{ 
                mr: 2,
                color: '#FFFFFF',
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              fontSize: { xs: '1.1rem', sm: '1.25rem' },
              fontWeight: 600,
              color: '#FFFFFF',
            }}
          >
            {churchName}
          </Typography>
          {user && (
            <>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  display: { xs: 'none', sm: 'block' },
                  mr: 2,
                }}
              >
                {user.name} ({getRoleDisplay(user.role)})
              </Typography>
              <IconButton
                color="inherit"
                aria-label="notifications"
                onClick={() => {
                  if (user.role === 'church_user') {
                    navigate('/church-user/notifications');
                  } else if (user.role === 'church_admin') {
                    navigate('/church-admin/notifications');
                  } else if (user.role === 'super_admin') {
                    navigate('/super-admin/notifications');
                  }
                }}
                sx={{
                  color: '#FFFFFF',
                  mr: 1,
                }}
              >
                <NotificationsIcon />
              </IconButton>
              <IconButton
                color="inherit"
                aria-label="profile"
                onClick={() => {
                  if (user.role === 'church_user') {
                    navigate('/church-user/profile');
                  } else if (user.role === 'church_admin') {
                    navigate('/church-admin/my-profile');
                  } else if (user.role === 'super_admin') {
                    navigate('/super-admin/profile');
                  }
                }}
                sx={{
                  color: '#FFFFFF',
                }}
              >
                <PersonIcon />
              </IconButton>
            </>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Spacer to account for fixed AppBar */}
    </>
  );
}

export default Header;

